import React ,{useState} from 'react';
import email from '../assets/email.svg'
import lock from '../assets/lock.svg'
import voltar from '../assets/voltar.svg'
import user from '../assets/user.svg'
import { useFormik } from 'formik';
import api from '../config/api'
import PassShowHide from '../components/passShowHide'

const validate = values => {
    const errors = {};
    if (!values.username) {
      errors.username = 'Campo obrigatório';
    } else if (values.username.length > 30) {
      errors.username = 'Precisa ter 30 caracteres ou menos';
    }
  
    if (!values.email) {
      errors.email = 'Campo obrigatório';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = 'Digite um email válido';
    }

    if (!values.password) {
        errors.password = 'Campo obrigatório';
      } else if (values.password.length < 6) {
        errors.password = 'Precisa ter 6 caracteres ou mais';
      }
    
      if (!values.confirmPassword) {
        errors.confirmPassword = 'Campo obrigatório';
      } else if (values.confirmPassword < 6) {
        errors.confirmPassword = 'Must be 6 characters or more';
      } else if (values.confirmPassword !== values.password) {
        errors.confirmPassword = 'As senhas não conferem';
      }
  
    return errors;
  };

export default function SignUp({history}) {

    const [typeError,setType] = useState(false)

    const formik = useFormik({
        initialValues: {
          username: '',
          email: '',
          password: '',
          confirmPassword:'',
        },
        validate,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: values => {
          delete values.confirmPassword
          
          api.post('/users', values)
            .then(function (response) {
                localStorage.setItem('token',response.data.token)
                history.push('home')
            })
            .catch(function (error) {
              if(error.response.data.message === "email exists"){
                setType('O email fornecido já foi cadastrado')
                formik.setFieldValue('password','')
                formik.setFieldValue('confirmPassword','')
                formik.setFieldValue('email','')
              } else if(error.response.data.message === "error in requisition of db") {
                setType('Falha interna no servidor tente novamente mais tarde')
                formik.setFieldValue('username','')
                formik.setFieldValue('email','')
                formik.setFieldValue('password','')
                formik.setFieldValue('confirmPassword','')
              }
            });
        },
      });

    function handleLogin(event) {
        event.preventDefault();
        history.push('login')
    }
    return (
        <>
            <div className='container login d-flex flex-column align-items-center bg-light'>
                <a className="navbar-brand pb-2 socialLogos voltar" href="/login" >
                    <img className="mb-3" src={voltar} alt="logo" width="24" height="24" onClick={event=>handleLogin(event)} href='.' />
                </a>

                <h4 className='mb-4'>Cadastro</h4>

                <form className='form' onSubmit={formik.handleSubmit}>
                

                    <div className="input-group input-group mb-4 mr-sm-2">
                    {typeError ? <small id="emailHelp" className="infosLogin">{typeError}</small> : null}
                        <div className="input-group-prepend">
                            <div className= {formik.errors.username ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={user} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <input 
                            className= {formik.errors.username ? "form-control borderRed" : "form-control"}
                            id="username" 
                            name="username"
                            placeholder='Seu nome' 
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.username}/>
                        {formik.errors.username ? <div className='invalid'>{formik.errors.username}</div> : null}
                    </div>

                    <div className="input-group input-group mb-4 mr-sm-2">
                        <div className="input-group-prepend">
                            <div className={formik.errors.email ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={email} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <input 
                            className= {formik.errors.email ? "form-control borderRed" : "form-control"}
                            id="email" 
                            name="email"
                            placeholder='Seu email'
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            />
                        {formik.errors.email ? <div className='invalid'>{formik.errors.email}</div> : null}
                    </div>

                    <div className="input-group input-group mb-4 mr-sm-2">
                        <div className="input-group-prepend">
                            <div className= {formik.errors.password ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={lock} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <PassShowHide 
                            className= {formik.errors.password ? "form-control borderRed" : "form-control"} 
                            id="password" 
                            name="password"
                            placeholder='Senha de acesso'
                            onChange={formik.handleChange}
                            value={formik.values.password}/>
                        {formik.errors.password ? <div className='invalid'>{formik.errors.password}</div> : null}
                    </div>

                    <div className="input-group input-group mb-4 mr-sm-2">
                        <div className="input-group-prepend">
                            <div className={formik.errors.confirmPassword ? "input-group-text borderRed" : "input-group-text"}>
                                <img className="" src={lock} alt="logo" width="18" height="18" />
                            </div>
                        </div>
                        <PassShowHide 
                            className= {formik.errors.confirmPassword ? "form-control borderRed" : "form-control"}  
                            id="confirmPassword" 
                            name='confirmPassword'
                            placeholder='Confirme a senha de acesso'
                            onChange={formik.handleChange}
                            value={formik.values.confirmPassword}/>
                        {formik.errors.confirmPassword ? <div className='invalid'>{formik.errors.confirmPassword}</div> : null}
                    </div>
                    

                    <button className="btn btn-outline-dark btn-block w-100 mb-2" type="submit">Cadastrar</button>
                </form>
            </div>
        </>
    );
}